import { useCallback, useMemo } from 'react'

const useFooterButtons = ({
  onHideWithConfirmation,
  nextStep,
  previousStep,
  setShowValidationErrorBanner,
  onValidate,
  disableNext,
  onSave,
}) => {
  const validateThenProceed = useCallback(async () => {
    // onValidate needs to be an async function that returns if the fields have errors, please memoize it
    const hasErrors = await onValidate()
    if (hasErrors) {
      setShowValidationErrorBanner(true)
    } else {
      setShowValidationErrorBanner(false)
      nextStep()
    }
  }, [nextStep, setShowValidationErrorBanner, onValidate])

  const buttons = useMemo(
    () => ({
      cancel: {
        variant: 'secondary',
        label: 'GENERAL.CANCEL',
        onClick: onHideWithConfirmation,
      },
      close: {
        variant: 'secondary',
        label: 'GENERAL.CLOSE',
        onClick: onHideWithConfirmation,
      },
      back: {
        variant: 'secondary',
        label: 'GENERAL.BACK',
        onClick: previousStep,
      },
      next: {
        variant: 'primary',
        label: 'GENERAL.NEXT',
        onClick: nextStep,
        disabled: disableNext,
      },
      validateThenProceed: {
        variant: 'primary',
        label: 'GENERAL.NEXT',
        onClick: validateThenProceed,
        disabled: disableNext,
      },
      save: {
        variant: 'primary',
        label: 'GENERAL.SAVE',
        onClick: onSave || onHideWithConfirmation,
      },
    }),
    [onHideWithConfirmation, nextStep, previousStep, validateThenProceed, disableNext, onSave],
  )

  return buttons
}

export default useFooterButtons
